module.exports = __webpack_public_path__ + "img/12.4f35d9b1.jpg";